<div mat-dialog-title>
  <div class="title-dialog">Schedule Maintenance</div>
</div>
<mat-dialog-content>
  <form [formGroup]="maintenanceForm" class="maintenance-form">
    <div class="time-container">
      <dx-date-box
        label="Start Date*"
        labelMode="floating"
        stylingMode="outlined"
        formControlName="startDate"
        placeholder="Select a date"
        type="date"
        [min]="minDate"
      ></dx-date-box>
      <dx-date-box
        label="Start Time*"
        labelMode="floating"
        stylingMode="outlined"
        type="time"
        formControlName="startHour"
        [inputAttr]="{ 'aria-label': 'Time' }"
        displayFormat="HH:mm"
      >
      </dx-date-box>
    </div>
    <div class="time-container">
      <dx-date-box
        label="End Date*"
        labelMode="floating"
        stylingMode="outlined"
        formControlName="endDate"
        placeholder="Select a date"
        type="date"
        [min]="minDate"
      ></dx-date-box>
      <dx-date-box
        label="End Time*"
        labelMode="floating"
        stylingMode="outlined"
        type="time"
        formControlName="endHour"
        [inputAttr]="{ 'aria-label': 'Time' }"
        displayFormat="HH:mm"
      >
      </dx-date-box>
    </div>
    <div class="time-zone-info">
      {{ timeZoneInfo }}
    </div>
    <div class="custom-alert-checkbox">
      <label>Enable alert from date</label>
      <dx-check-box (onValueChanged)="customAlertShowDate.set($event.value)" [value]="customAlertShowDate()"></dx-check-box>
    </div>
    <dx-date-box
      *ngIf="customAlertShowDate()"
      label="Alert Date"
      labelMode="floating"
      stylingMode="outlined"
      formControlName="alertShowDate"
      placeholder="Select a date"
      type="date"
      [min]="minDate"
    ></dx-date-box>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <brd-button text="cancel" color="primary" (clickEvent)="close()"></brd-button>
  <brd-button *ngIf="maintenanceId() !== 0" text="delete" class="delete-button" (clickEvent)="deleteMaintenance()"></brd-button>
  <brd-button [text]="maintenanceId() !== 0 ? 'Update' : 'Create'" (clickEvent)="createMaintenance()"></brd-button>
</mat-dialog-actions>
